module.exports = __webpack_public_path__ + "static/img/unuser_head.5d8a082b.svg";